module.exports = __webpack_public_path__ + "img/Chinese.03ae0172.png";